module.exports = __webpack_public_path__ + "fonts/Rubik-400-arabic64.d2ec738.woff2";